import { render, staticRenderFns } from "./Gems.vue?vue&type=template&id=36a577eb&"
import script from "./Gems.vue?vue&type=script&lang=js&"
export * from "./Gems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports